// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActionBank, ActionBankT, verifyActionBank } from "./action-bank";
import { BankFloor, BankFloorT, verifyBankFloor } from "./bank-floor";
import { Lift, LiftT, verifyLift } from "./lift";
import { LiftType } from "./lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Full bank record matching the `banks` `PostgreSQL` table.
 */
export class Bank implements flatbuffers.IUnpackableObject<BankT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Bank {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBank(bb: flatbuffers.ByteBuffer, obj?: Bank): Bank {
    return (obj || new Bank()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBank(bb: flatbuffers.ByteBuffer, obj?: Bank): Bank {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Bank()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  channelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  adapterId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  orgId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  type(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  rearDoors(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  numberOfLifts(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  floorCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  floorBelowLobby(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  startFloorNo(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 1;
  }

  stops(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  columns(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  board(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  questId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  logicalPort(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * Binary `FlatBuffer` blobs — same pattern as Adapter.
   */
  interfaceBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  interfaceBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  interfaceBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  offsetMappingBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  offsetMappingBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  offsetMappingBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  socketMessagePriorityBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  socketMessagePriorityBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  socketMessagePriorityBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  intraContentFlagsBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  intraContentFlagsBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  intraContentFlagsBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  /**
   * JSON fallbacks for debugging.
   */
  interfaceJson(): string | null;
  interfaceJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  interfaceJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  offsetMappingJson(): string | null;
  offsetMappingJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  offsetMappingJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  socketMessagePriorityJson(): string | null;
  socketMessagePriorityJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  socketMessagePriorityJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  intraContentFlagsJson(): string | null;
  intraContentFlagsJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  intraContentFlagsJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  disabledColumnsJson(): string | null;
  disabledColumnsJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  disabledColumnsJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Nested relations — populated by `FindBankByID`.
   */
  bankFloors(index: number, obj?: BankFloor): BankFloor | null {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset
      ? (obj || new BankFloor()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bankFloorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  lifts(index: number, obj?: Lift): Lift | null {
    const offset = this.bb!.__offset(this.bb_pos, 64);
    return offset
      ? (obj || new Lift()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  liftsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 64);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  actions(index: number, obj?: ActionBank): ActionBank | null {
    const offset = this.bb!.__offset(this.bb_pos, 66);
    return offset
      ? (obj || new ActionBank()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  actionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 66);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Bank-level door toggle — new field appended at end for `FlatBuffer` compatibility.
   */
  frontDoors(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 68);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * UI visibility flag — when false, the bank still sends/receives LN2 messages
   * but is hidden from frontend listings/grids. Defaults to true so existing banks
   * remain visible. Appended at end of table for `FlatBuffer` wire compatibility.
   */
  visible(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 70);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * OPC UA per-bank node->lift binding (bank-scoped; the shared adapter Mapping
   * is bank-agnostic). Carries a packed `Config.OpcUaNodeLiftIndexBindings`
   * `FlatBuffer` (see `schemas/config/opcua_bank_binding.fbs`) over the binary bank
   * wire path. Appended at end of table for `FlatBuffer` wire compatibility.
   */
  opcUaNodeLiftMappingBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 72);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  opcUaNodeLiftMappingBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 72);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  opcUaNodeLiftMappingBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 72);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  /**
   * Per-bank `MCE` event/fault UDP reporting address ("host:port"), collected by the
   * wizard's Banks step and the sole input to the edge `CDO`'s
   * `CDO.MceEventReportingBinding`. NOT the same field as the CHANNEL-scoped
   * `Archive.Channel.reporting_socket_address` / `Archive.ChannelEndpoint
   * .reporting_socket_address`: one physical `MCE` adapter can serve several banks,
   * and each bank's `VTS` task binds its own local UDP socket, so this address must
   * be distinct per bank and cannot live on the channel or the adapter. Completes the
   * scope migration begun when `Mce.Mapping.event_reporting_address` and
   * `Config.MceConfig.event_reporting_address` were deprecated in favor of the
   * bank-scoped `CDO.MceEventReportingBinding` — the destination moved to bank scope,
   * but until this field, the bank-scoped source had no wire representation, so the
   * binary bank path (wizard Create/UpdateBank, cloud<->edge sync, org export) could
   * not carry it at all.
   *
   * `FlatBuffers` cannot express a null string: the empty string is indistinguishable
   * from absent and means UNSET. Do not write `""` to mean "configured but blank" —
   * `buildMceEventReportingBinding` (`LiftCloud`) rejects both nil and `""` identically.
   *
   * Appended at end of table for `FlatBuffer` wire compatibility.
   */
  eventReportingAddress(): string | null;
  eventReportingAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  eventReportingAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 76);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * OPC deployment path — the LOCATION segment of this bank's vendor node path,
   * written to `Opc.Location.name` (e.g. `BNA_Nash`, or `MoffittSperos` for the
   * Kone OPC UA equivalent).
   *
   * This and the two fields below exist so ONE adapter can serve every site of a
   * given controller type. Kone KICs expose identical leaf names
   * (`LiftMode`, "DoorMode.Side1") at every building; only the path above the leaf
   * differs. The leaves stay on the adapter; these per-deployment segments live
   * here, and `LiftCloud` joins them when it assembles the edge CDO.
   *
   * Named for the `Opc` tree level it populates, deliberately: all four levels are
   * independent (a site whose group is named differently from the site is normal),
   * so a name that does not state its target level gets wired to the wrong one.
   *
   * `FlatBuffers` cannot express a null string, so the empty string is
   * indistinguishable from unset — do NOT use emptiness as the "not migrated"
   * signal. `Opc.Mapping.vendor_addressing` is the discriminator. Appended at end
   * of table for `FlatBuffer` wire compatibility.
   */
  vendorLocationPath(): string | null;
  vendorLocationPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorLocationPath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 78);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * OPC deployment path — the SITE segment beneath `vendor_location_path`, written
   * to `Opc.Site.name` (e.g. `G1_G5`, or "Group0" for Kone OPC UA). Appended at end
   * of table for `FlatBuffer` wire compatibility.
   */
  vendorSitePath(): string | null;
  vendorSitePath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorSitePath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 80);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * OPC DA deployment path — the GROUP segment beneath `vendor_site_path`, written
   * to `Opc.Group.path_name` (e.g. `G1_G5`).
   *
   * Distinct from `vendor_site_path` even though every dictionary captured so far
   * happens to set the two equal: `opc_protocol`'s `Localization` builds a fixed
   * 3-or-4 segment prefix with `format!` and cannot skip an empty component, so all
   * levels must be non-empty for OPC DA. OPC UA composes its own string and skips
   * empty segments, so UA deployments normally leave this empty. Appended at end of
   * table for `FlatBuffer` wire compatibility.
   */
  vendorGroupPath(): string | null;
  vendorGroupPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorGroupPath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 82);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Presence signal for the three `OPC` vendor path segments above.
   *
   * `FlatBuffers` cannot express a null string, so on the wire an empty segment and
   * an absent one are byte-identical, and `LiftCloud` cannot tell "the operator
   * cleared this path" apart from "this client never models the field." Without a
   * signal, the update path can only ever overwrite a stored segment, never clear it.
   *
   * When this is `true`, the editor is authoritative over ALL THREE segments for
   * this save: `LiftCloud` writes each segment to its value, or to `NULL` when it is
   * empty/whitespace (so a cleared input deletes the stored path). A deployment that
   * legitimately has no group segment (OPC `UA`) sends `true` with an empty
   * `vendor_group_path` and the column is cleared — which is correct, not a loss.
   *
   * When this is `false` (the default), the three segments are treated as
   * NOT-PROVIDED and the stored columns are left untouched — the exact guarded
   * behaviour every existing client relies on. Old senders that predate this field
   * read `false` (the `FlatBuffer` default), so appending it is fully backward- and
   * forward-compatible: no client that does not explicitly set it can clear a path,
   * and no client has to be updated in lockstep for existing saves to keep working.
   *
   * Only the two editors that round-trip all three segments together (the Setup
   * Wizard's `Banks` step and the standalone bank form) set this `true`. Appended at
   * end of table for `FlatBuffer` wire compatibility.
   */
  vendorPathsProvided(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 84);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startBank(builder: flatbuffers.Builder) {
    builder.startObject(41);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addChannelId(builder: flatbuffers.Builder, channelIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, channelIdOffset, 0);
  }

  static addAdapterId(builder: flatbuffers.Builder, adapterIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, adapterIdOffset, 0);
  }

  static addOrgId(builder: flatbuffers.Builder, orgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, orgIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, nameOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: LiftType) {
    builder.addFieldInt8(5, type, LiftType.ELEVATOR);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(6, +active, +true);
  }

  static addRearDoors(builder: flatbuffers.Builder, rearDoors: boolean) {
    builder.addFieldInt8(7, +rearDoors, +false);
  }

  static addNumberOfLifts(builder: flatbuffers.Builder, numberOfLifts: number) {
    builder.addFieldInt32(8, numberOfLifts, 0);
  }

  static addFloorCount(builder: flatbuffers.Builder, floorCount: number) {
    builder.addFieldInt32(9, floorCount, 0);
  }

  static addFloorBelowLobby(builder: flatbuffers.Builder, floorBelowLobby: number) {
    builder.addFieldInt32(10, floorBelowLobby, 0);
  }

  static addStartFloorNo(builder: flatbuffers.Builder, startFloorNo: number) {
    builder.addFieldInt32(11, startFloorNo, 1);
  }

  static addStops(builder: flatbuffers.Builder, stops: number) {
    builder.addFieldInt32(12, stops, 0);
  }

  static addColumns(builder: flatbuffers.Builder, columns: number) {
    builder.addFieldInt32(13, columns, 0);
  }

  static addBoard(builder: flatbuffers.Builder, board: number) {
    builder.addFieldInt32(14, board, 0);
  }

  static addQuestId(builder: flatbuffers.Builder, questId: number) {
    builder.addFieldInt16(15, questId, 0);
  }

  static addLogicalPort(builder: flatbuffers.Builder, logicalPort: number) {
    builder.addFieldInt16(16, logicalPort, 0);
  }

  static addInterfaceBinary(
    builder: flatbuffers.Builder,
    interfaceBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(17, interfaceBinaryOffset, 0);
  }

  static createInterfaceBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startInterfaceBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addOffsetMappingBinary(
    builder: flatbuffers.Builder,
    offsetMappingBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(18, offsetMappingBinaryOffset, 0);
  }

  static createOffsetMappingBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startOffsetMappingBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addSocketMessagePriorityBinary(
    builder: flatbuffers.Builder,
    socketMessagePriorityBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(19, socketMessagePriorityBinaryOffset, 0);
  }

  static createSocketMessagePriorityBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startSocketMessagePriorityBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addIntraContentFlagsBinary(
    builder: flatbuffers.Builder,
    intraContentFlagsBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(20, intraContentFlagsBinaryOffset, 0);
  }

  static createIntraContentFlagsBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startIntraContentFlagsBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addInterfaceJson(builder: flatbuffers.Builder, interfaceJsonOffset: flatbuffers.Offset) {
    builder.addFieldOffset(21, interfaceJsonOffset, 0);
  }

  static addOffsetMappingJson(
    builder: flatbuffers.Builder,
    offsetMappingJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(22, offsetMappingJsonOffset, 0);
  }

  static addSocketMessagePriorityJson(
    builder: flatbuffers.Builder,
    socketMessagePriorityJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(23, socketMessagePriorityJsonOffset, 0);
  }

  static addIntraContentFlagsJson(
    builder: flatbuffers.Builder,
    intraContentFlagsJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(24, intraContentFlagsJsonOffset, 0);
  }

  static addDisabledColumnsJson(
    builder: flatbuffers.Builder,
    disabledColumnsJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(25, disabledColumnsJsonOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(26, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(27, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(28, deletedAtOffset, 0);
  }

  static addBankFloors(builder: flatbuffers.Builder, bankFloorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(29, bankFloorsOffset, 0);
  }

  static createBankFloorsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBankFloorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addLifts(builder: flatbuffers.Builder, liftsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(30, liftsOffset, 0);
  }

  static createLiftsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLiftsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActions(builder: flatbuffers.Builder, actionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(31, actionsOffset, 0);
  }

  static createActionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startActionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addFrontDoors(builder: flatbuffers.Builder, frontDoors: boolean) {
    builder.addFieldInt8(32, +frontDoors, +true);
  }

  static addVisible(builder: flatbuffers.Builder, visible: boolean) {
    builder.addFieldInt8(33, +visible, +true);
  }

  static addOpcUaNodeLiftMappingBinary(
    builder: flatbuffers.Builder,
    opcUaNodeLiftMappingBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(34, opcUaNodeLiftMappingBinaryOffset, 0);
  }

  static createOpcUaNodeLiftMappingBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startOpcUaNodeLiftMappingBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addEventReportingAddress(
    builder: flatbuffers.Builder,
    eventReportingAddressOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(36, eventReportingAddressOffset, 0);
  }

  static addVendorLocationPath(
    builder: flatbuffers.Builder,
    vendorLocationPathOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(37, vendorLocationPathOffset, 0);
  }

  static addVendorSitePath(builder: flatbuffers.Builder, vendorSitePathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(38, vendorSitePathOffset, 0);
  }

  static addVendorGroupPath(
    builder: flatbuffers.Builder,
    vendorGroupPathOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(39, vendorGroupPathOffset, 0);
  }

  static addVendorPathsProvided(builder: flatbuffers.Builder, vendorPathsProvided: boolean) {
    builder.addFieldInt8(40, +vendorPathsProvided, +false);
  }

  static endBank(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // channel_id
    builder.requiredField(offset, 10); // org_id
    builder.requiredField(offset, 12); // name
    return offset;
  }

  unpack(): BankT {
    return new BankT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.channelId() !== null ? this.channelId()!.unpack() : null,
      this.adapterId() !== null ? this.adapterId()!.unpack() : null,
      this.orgId() !== null ? this.orgId()!.unpack() : null,
      this.name(),
      this.type(),
      this.active(),
      this.rearDoors(),
      this.numberOfLifts(),
      this.floorCount(),
      this.floorBelowLobby(),
      this.startFloorNo(),
      this.stops(),
      this.columns(),
      this.board(),
      this.questId(),
      this.logicalPort(),
      this.bb!.createScalarList<number>(
        this.interfaceBinary.bind(this),
        this.interfaceBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.offsetMappingBinary.bind(this),
        this.offsetMappingBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.socketMessagePriorityBinary.bind(this),
        this.socketMessagePriorityBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.intraContentFlagsBinary.bind(this),
        this.intraContentFlagsBinaryLength(),
      ),
      this.interfaceJson(),
      this.offsetMappingJson(),
      this.socketMessagePriorityJson(),
      this.intraContentFlagsJson(),
      this.disabledColumnsJson(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<BankFloor, BankFloorT>(
        this.bankFloors.bind(this),
        this.bankFloorsLength(),
      ),
      this.bb!.createObjList<Lift, LiftT>(this.lifts.bind(this), this.liftsLength()),
      this.bb!.createObjList<ActionBank, ActionBankT>(
        this.actions.bind(this),
        this.actionsLength(),
      ),
      this.frontDoors(),
      this.visible(),
      this.bb!.createScalarList<number>(
        this.opcUaNodeLiftMappingBinary.bind(this),
        this.opcUaNodeLiftMappingBinaryLength(),
      ),
      this.eventReportingAddress(),
      this.vendorLocationPath(),
      this.vendorSitePath(),
      this.vendorGroupPath(),
      this.vendorPathsProvided(),
    );
  }

  unpackTo(_o: BankT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    _o.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    _o.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    _o.name = this.name();
    _o.type = this.type();
    _o.active = this.active();
    _o.rearDoors = this.rearDoors();
    _o.numberOfLifts = this.numberOfLifts();
    _o.floorCount = this.floorCount();
    _o.floorBelowLobby = this.floorBelowLobby();
    _o.startFloorNo = this.startFloorNo();
    _o.stops = this.stops();
    _o.columns = this.columns();
    _o.board = this.board();
    _o.questId = this.questId();
    _o.logicalPort = this.logicalPort();
    _o.interfaceBinary = this.bb!.createScalarList<number>(
      this.interfaceBinary.bind(this),
      this.interfaceBinaryLength(),
    );
    _o.offsetMappingBinary = this.bb!.createScalarList<number>(
      this.offsetMappingBinary.bind(this),
      this.offsetMappingBinaryLength(),
    );
    _o.socketMessagePriorityBinary = this.bb!.createScalarList<number>(
      this.socketMessagePriorityBinary.bind(this),
      this.socketMessagePriorityBinaryLength(),
    );
    _o.intraContentFlagsBinary = this.bb!.createScalarList<number>(
      this.intraContentFlagsBinary.bind(this),
      this.intraContentFlagsBinaryLength(),
    );
    _o.interfaceJson = this.interfaceJson();
    _o.offsetMappingJson = this.offsetMappingJson();
    _o.socketMessagePriorityJson = this.socketMessagePriorityJson();
    _o.intraContentFlagsJson = this.intraContentFlagsJson();
    _o.disabledColumnsJson = this.disabledColumnsJson();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.bankFloors = this.bb!.createObjList<BankFloor, BankFloorT>(
      this.bankFloors.bind(this),
      this.bankFloorsLength(),
    );
    _o.lifts = this.bb!.createObjList<Lift, LiftT>(this.lifts.bind(this), this.liftsLength());
    _o.actions = this.bb!.createObjList<ActionBank, ActionBankT>(
      this.actions.bind(this),
      this.actionsLength(),
    );
    _o.frontDoors = this.frontDoors();
    _o.visible = this.visible();
    _o.opcUaNodeLiftMappingBinary = this.bb!.createScalarList<number>(
      this.opcUaNodeLiftMappingBinary.bind(this),
      this.opcUaNodeLiftMappingBinaryLength(),
    );
    _o.eventReportingAddress = this.eventReportingAddress();
    _o.vendorLocationPath = this.vendorLocationPath();
    _o.vendorSitePath = this.vendorSitePath();
    _o.vendorGroupPath = this.vendorGroupPath();
    _o.vendorPathsProvided = this.vendorPathsProvided();
  }

  unpackFields(...fields: string[]): BankT {
    const t = new BankT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("channel_id")) {
      t.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    }
    if (fieldSet.has("adapter_id")) {
      t.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    }
    if (fieldSet.has("org_id")) {
      t.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("rear_doors")) {
      t.rearDoors = this.rearDoors();
    }
    if (fieldSet.has("number_of_lifts")) {
      t.numberOfLifts = this.numberOfLifts();
    }
    if (fieldSet.has("floor_count")) {
      t.floorCount = this.floorCount();
    }
    if (fieldSet.has("floor_below_lobby")) {
      t.floorBelowLobby = this.floorBelowLobby();
    }
    if (fieldSet.has("start_floor_no")) {
      t.startFloorNo = this.startFloorNo();
    }
    if (fieldSet.has("stops")) {
      t.stops = this.stops();
    }
    if (fieldSet.has("columns")) {
      t.columns = this.columns();
    }
    if (fieldSet.has("board")) {
      t.board = this.board();
    }
    if (fieldSet.has("quest_id")) {
      t.questId = this.questId();
    }
    if (fieldSet.has("logical_port")) {
      t.logicalPort = this.logicalPort();
    }
    if (fieldSet.has("interface_binary")) {
      t.interfaceBinary = this.bb!.createScalarList<number>(
        this.interfaceBinary.bind(this),
        this.interfaceBinaryLength(),
      );
    }
    if (fieldSet.has("offset_mapping_binary")) {
      t.offsetMappingBinary = this.bb!.createScalarList<number>(
        this.offsetMappingBinary.bind(this),
        this.offsetMappingBinaryLength(),
      );
    }
    if (fieldSet.has("socket_message_priority_binary")) {
      t.socketMessagePriorityBinary = this.bb!.createScalarList<number>(
        this.socketMessagePriorityBinary.bind(this),
        this.socketMessagePriorityBinaryLength(),
      );
    }
    if (fieldSet.has("intra_content_flags_binary")) {
      t.intraContentFlagsBinary = this.bb!.createScalarList<number>(
        this.intraContentFlagsBinary.bind(this),
        this.intraContentFlagsBinaryLength(),
      );
    }
    if (fieldSet.has("interface_json")) {
      t.interfaceJson = this.interfaceJson();
    }
    if (fieldSet.has("offset_mapping_json")) {
      t.offsetMappingJson = this.offsetMappingJson();
    }
    if (fieldSet.has("socket_message_priority_json")) {
      t.socketMessagePriorityJson = this.socketMessagePriorityJson();
    }
    if (fieldSet.has("intra_content_flags_json")) {
      t.intraContentFlagsJson = this.intraContentFlagsJson();
    }
    if (fieldSet.has("disabled_columns_json")) {
      t.disabledColumnsJson = this.disabledColumnsJson();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("bank_floors")) {
      t.bankFloors = this.bb!.createObjList<BankFloor, BankFloorT>(
        this.bankFloors.bind(this),
        this.bankFloorsLength(),
      );
    }
    if (fieldSet.has("lifts")) {
      t.lifts = this.bb!.createObjList<Lift, LiftT>(this.lifts.bind(this), this.liftsLength());
    }
    if (fieldSet.has("actions")) {
      t.actions = this.bb!.createObjList<ActionBank, ActionBankT>(
        this.actions.bind(this),
        this.actionsLength(),
      );
    }
    if (fieldSet.has("front_doors")) {
      t.frontDoors = this.frontDoors();
    }
    if (fieldSet.has("visible")) {
      t.visible = this.visible();
    }
    if (fieldSet.has("opc_ua_node_lift_mapping_binary")) {
      t.opcUaNodeLiftMappingBinary = this.bb!.createScalarList<number>(
        this.opcUaNodeLiftMappingBinary.bind(this),
        this.opcUaNodeLiftMappingBinaryLength(),
      );
    }
    if (fieldSet.has("event_reporting_address")) {
      t.eventReportingAddress = this.eventReportingAddress();
    }
    if (fieldSet.has("vendor_location_path")) {
      t.vendorLocationPath = this.vendorLocationPath();
    }
    if (fieldSet.has("vendor_site_path")) {
      t.vendorSitePath = this.vendorSitePath();
    }
    if (fieldSet.has("vendor_group_path")) {
      t.vendorGroupPath = this.vendorGroupPath();
    }
    if (fieldSet.has("vendor_paths_provided")) {
      t.vendorPathsProvided = this.vendorPathsProvided();
    }
    return t;
  }
}

export class BankT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public channelId: UuidT | null = null,
    public adapterId: UuidT | null = null,
    public orgId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public type: LiftType = LiftType.ELEVATOR,
    public active: boolean = true,
    public rearDoors: boolean = false,
    public numberOfLifts: number = 0,
    public floorCount: number = 0,
    public floorBelowLobby: number = 0,
    public startFloorNo: number = 1,
    public stops: number = 0,
    public columns: number = 0,
    public board: number = 0,
    public questId: number = 0,
    public logicalPort: number = 0,
    public interfaceBinary: number[] = [],
    public offsetMappingBinary: number[] = [],
    public socketMessagePriorityBinary: number[] = [],
    public intraContentFlagsBinary: number[] = [],
    public interfaceJson: string | Uint8Array | null = null,
    public offsetMappingJson: string | Uint8Array | null = null,
    public socketMessagePriorityJson: string | Uint8Array | null = null,
    public intraContentFlagsJson: string | Uint8Array | null = null,
    public disabledColumnsJson: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public bankFloors: BankFloorT[] = [],
    public lifts: LiftT[] = [],
    public actions: ActionBankT[] = [],
    public frontDoors: boolean = true,
    public visible: boolean = true,
    public opcUaNodeLiftMappingBinary: number[] = [],
    public eventReportingAddress: string | Uint8Array | null = null,
    public vendorLocationPath: string | Uint8Array | null = null,
    public vendorSitePath: string | Uint8Array | null = null,
    public vendorGroupPath: string | Uint8Array | null = null,
    public vendorPathsProvided: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.channelId === null || this.channelId === undefined) {
      throw new Error('Required field "channel_id" is not set');
    }
    if (this.orgId === null || this.orgId === undefined) {
      throw new Error('Required field "org_id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const channelId = this.channelId !== null ? this.channelId!.pack(builder) : 0;
    const adapterId = this.adapterId !== null ? this.adapterId!.pack(builder) : 0;
    const orgId = this.orgId !== null ? this.orgId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const interfaceBinary = Bank.createInterfaceBinaryVector(builder, this.interfaceBinary);
    const offsetMappingBinary = Bank.createOffsetMappingBinaryVector(
      builder,
      this.offsetMappingBinary,
    );
    const socketMessagePriorityBinary = Bank.createSocketMessagePriorityBinaryVector(
      builder,
      this.socketMessagePriorityBinary,
    );
    const intraContentFlagsBinary = Bank.createIntraContentFlagsBinaryVector(
      builder,
      this.intraContentFlagsBinary,
    );
    const interfaceJson =
      this.interfaceJson !== null ? builder.createString(this.interfaceJson!) : 0;
    const offsetMappingJson =
      this.offsetMappingJson !== null ? builder.createString(this.offsetMappingJson!) : 0;
    const socketMessagePriorityJson =
      this.socketMessagePriorityJson !== null
        ? builder.createString(this.socketMessagePriorityJson!)
        : 0;
    const intraContentFlagsJson =
      this.intraContentFlagsJson !== null ? builder.createString(this.intraContentFlagsJson!) : 0;
    const disabledColumnsJson =
      this.disabledColumnsJson !== null ? builder.createString(this.disabledColumnsJson!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const bankFloors = Bank.createBankFloorsVector(
      builder,
      builder.createObjectOffsetList(this.bankFloors),
    );
    const lifts = Bank.createLiftsVector(builder, builder.createObjectOffsetList(this.lifts));
    const actions = Bank.createActionsVector(builder, builder.createObjectOffsetList(this.actions));
    const opcUaNodeLiftMappingBinary = Bank.createOpcUaNodeLiftMappingBinaryVector(
      builder,
      this.opcUaNodeLiftMappingBinary,
    );
    const eventReportingAddress =
      this.eventReportingAddress !== null ? builder.createString(this.eventReportingAddress!) : 0;
    const vendorLocationPath =
      this.vendorLocationPath !== null ? builder.createString(this.vendorLocationPath!) : 0;
    const vendorSitePath =
      this.vendorSitePath !== null ? builder.createString(this.vendorSitePath!) : 0;
    const vendorGroupPath =
      this.vendorGroupPath !== null ? builder.createString(this.vendorGroupPath!) : 0;

    Bank.startBank(builder);
    Bank.addId(builder, id);
    Bank.addChannelId(builder, channelId);
    Bank.addAdapterId(builder, adapterId);
    Bank.addOrgId(builder, orgId);
    Bank.addName(builder, name);
    Bank.addType(builder, this.type);
    Bank.addActive(builder, this.active);
    Bank.addRearDoors(builder, this.rearDoors);
    Bank.addNumberOfLifts(builder, this.numberOfLifts);
    Bank.addFloorCount(builder, this.floorCount);
    Bank.addFloorBelowLobby(builder, this.floorBelowLobby);
    Bank.addStartFloorNo(builder, this.startFloorNo);
    Bank.addStops(builder, this.stops);
    Bank.addColumns(builder, this.columns);
    Bank.addBoard(builder, this.board);
    Bank.addQuestId(builder, this.questId);
    Bank.addLogicalPort(builder, this.logicalPort);
    Bank.addInterfaceBinary(builder, interfaceBinary);
    Bank.addOffsetMappingBinary(builder, offsetMappingBinary);
    Bank.addSocketMessagePriorityBinary(builder, socketMessagePriorityBinary);
    Bank.addIntraContentFlagsBinary(builder, intraContentFlagsBinary);
    Bank.addInterfaceJson(builder, interfaceJson);
    Bank.addOffsetMappingJson(builder, offsetMappingJson);
    Bank.addSocketMessagePriorityJson(builder, socketMessagePriorityJson);
    Bank.addIntraContentFlagsJson(builder, intraContentFlagsJson);
    Bank.addDisabledColumnsJson(builder, disabledColumnsJson);
    Bank.addCreatedAt(builder, createdAt);
    Bank.addUpdatedAt(builder, updatedAt);
    Bank.addDeletedAt(builder, deletedAt);
    Bank.addBankFloors(builder, bankFloors);
    Bank.addLifts(builder, lifts);
    Bank.addActions(builder, actions);
    Bank.addFrontDoors(builder, this.frontDoors);
    Bank.addVisible(builder, this.visible);
    Bank.addOpcUaNodeLiftMappingBinary(builder, opcUaNodeLiftMappingBinary);
    Bank.addEventReportingAddress(builder, eventReportingAddress);
    Bank.addVendorLocationPath(builder, vendorLocationPath);
    Bank.addVendorSitePath(builder, vendorSitePath);
    Bank.addVendorGroupPath(builder, vendorGroupPath);
    Bank.addVendorPathsProvided(builder, this.vendorPathsProvided);

    return Bank.endBank(builder);
  }

  clone(): BankT {
    const obj = new BankT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.channelId = this.channelId !== null ? this.channelId!.clone() : null;
    obj.adapterId = this.adapterId !== null ? this.adapterId!.clone() : null;
    obj.orgId = this.orgId !== null ? this.orgId!.clone() : null;
    obj.name = this.name;
    obj.type = this.type;
    obj.active = this.active;
    obj.rearDoors = this.rearDoors;
    obj.numberOfLifts = this.numberOfLifts;
    obj.floorCount = this.floorCount;
    obj.floorBelowLobby = this.floorBelowLobby;
    obj.startFloorNo = this.startFloorNo;
    obj.stops = this.stops;
    obj.columns = this.columns;
    obj.board = this.board;
    obj.questId = this.questId;
    obj.logicalPort = this.logicalPort;
    obj.interfaceBinary = [...this.interfaceBinary];
    obj.offsetMappingBinary = [...this.offsetMappingBinary];
    obj.socketMessagePriorityBinary = [...this.socketMessagePriorityBinary];
    obj.intraContentFlagsBinary = [...this.intraContentFlagsBinary];
    obj.interfaceJson = this.interfaceJson;
    obj.offsetMappingJson = this.offsetMappingJson;
    obj.socketMessagePriorityJson = this.socketMessagePriorityJson;
    obj.intraContentFlagsJson = this.intraContentFlagsJson;
    obj.disabledColumnsJson = this.disabledColumnsJson;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.bankFloors = this.bankFloors.map((e) => e.clone());
    obj.lifts = this.lifts.map((e) => e.clone());
    obj.actions = this.actions.map((e) => e.clone());
    obj.frontDoors = this.frontDoors;
    obj.visible = this.visible;
    obj.opcUaNodeLiftMappingBinary = [...this.opcUaNodeLiftMappingBinary];
    obj.eventReportingAddress = this.eventReportingAddress;
    obj.vendorLocationPath = this.vendorLocationPath;
    obj.vendorSitePath = this.vendorSitePath;
    obj.vendorGroupPath = this.vendorGroupPath;
    obj.vendorPathsProvided = this.vendorPathsProvided;
    return obj;
  }

  equals(other: BankT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.channelId !== null && other.channelId !== null) {
      if (!this.channelId!.equals(other.channelId!)) return false;
    } else if (this.channelId !== other.channelId) return false;
    if (this.adapterId !== null && other.adapterId !== null) {
      if (!this.adapterId!.equals(other.adapterId!)) return false;
    } else if (this.adapterId !== other.adapterId) return false;
    if (this.orgId !== null && other.orgId !== null) {
      if (!this.orgId!.equals(other.orgId!)) return false;
    } else if (this.orgId !== other.orgId) return false;
    if (this.name !== other.name) return false;
    if (this.type !== other.type) return false;
    if (this.active !== other.active) return false;
    if (this.rearDoors !== other.rearDoors) return false;
    if (this.numberOfLifts !== other.numberOfLifts) return false;
    if (this.floorCount !== other.floorCount) return false;
    if (this.floorBelowLobby !== other.floorBelowLobby) return false;
    if (this.startFloorNo !== other.startFloorNo) return false;
    if (this.stops !== other.stops) return false;
    if (this.columns !== other.columns) return false;
    if (this.board !== other.board) return false;
    if (this.questId !== other.questId) return false;
    if (this.logicalPort !== other.logicalPort) return false;
    if (this.interfaceBinary.length !== other.interfaceBinary.length) return false;
    for (let i = 0; i < this.interfaceBinary.length; i++) {
      if (this.interfaceBinary[i] !== other.interfaceBinary[i]) return false;
    }
    if (this.offsetMappingBinary.length !== other.offsetMappingBinary.length) return false;
    for (let i = 0; i < this.offsetMappingBinary.length; i++) {
      if (this.offsetMappingBinary[i] !== other.offsetMappingBinary[i]) return false;
    }
    if (this.socketMessagePriorityBinary.length !== other.socketMessagePriorityBinary.length)
      return false;
    for (let i = 0; i < this.socketMessagePriorityBinary.length; i++) {
      if (this.socketMessagePriorityBinary[i] !== other.socketMessagePriorityBinary[i])
        return false;
    }
    if (this.intraContentFlagsBinary.length !== other.intraContentFlagsBinary.length) return false;
    for (let i = 0; i < this.intraContentFlagsBinary.length; i++) {
      if (this.intraContentFlagsBinary[i] !== other.intraContentFlagsBinary[i]) return false;
    }
    if (this.interfaceJson !== other.interfaceJson) return false;
    if (this.offsetMappingJson !== other.offsetMappingJson) return false;
    if (this.socketMessagePriorityJson !== other.socketMessagePriorityJson) return false;
    if (this.intraContentFlagsJson !== other.intraContentFlagsJson) return false;
    if (this.disabledColumnsJson !== other.disabledColumnsJson) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.bankFloors.length !== other.bankFloors.length) return false;
    for (let i = 0; i < this.bankFloors.length; i++) {
      const a = this.bankFloors[i];
      const b = other.bankFloors[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.lifts.length !== other.lifts.length) return false;
    for (let i = 0; i < this.lifts.length; i++) {
      const a = this.lifts[i];
      const b = other.lifts[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.actions.length !== other.actions.length) return false;
    for (let i = 0; i < this.actions.length; i++) {
      const a = this.actions[i];
      const b = other.actions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.frontDoors !== other.frontDoors) return false;
    if (this.visible !== other.visible) return false;
    if (this.opcUaNodeLiftMappingBinary.length !== other.opcUaNodeLiftMappingBinary.length)
      return false;
    for (let i = 0; i < this.opcUaNodeLiftMappingBinary.length; i++) {
      if (this.opcUaNodeLiftMappingBinary[i] !== other.opcUaNodeLiftMappingBinary[i]) return false;
    }
    if (this.eventReportingAddress !== other.eventReportingAddress) return false;
    if (this.vendorLocationPath !== other.vendorLocationPath) return false;
    if (this.vendorSitePath !== other.vendorSitePath) return false;
    if (this.vendorGroupPath !== other.vendorGroupPath) return false;
    if (this.vendorPathsProvided !== other.vendorPathsProvided) return false;
    return true;
  }
}

export function verifyBank(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "channel_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "org_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "name");
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkScalarField(tablePos, 18, 1);
    verifier.checkScalarField(tablePos, 20, 4);
    verifier.checkScalarField(tablePos, 22, 4);
    verifier.checkScalarField(tablePos, 24, 4);
    verifier.checkScalarField(tablePos, 26, 4);
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 4);
    verifier.checkScalarField(tablePos, 32, 4);
    verifier.checkScalarField(tablePos, 34, 2);
    verifier.checkScalarField(tablePos, 36, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 46);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 50);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 52);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 54);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 56);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 58);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 60);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 62);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyBankFloor);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 64);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyLift);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 66);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyActionBank);
      }
    }
    verifier.checkScalarField(tablePos, 68, 1);
    verifier.checkScalarField(tablePos, 70, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 72);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 76);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 78);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 80);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 82);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 84, 1);
  } finally {
    verifier.popDepth();
  }
}
